import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  data: {},
  isLoading: false,
  error: "",
  hasData: false
};
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    settingsRequest: state => {
      state.isLoading = true;
    },
    settingsSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.data = action.payload;
    },
    settingsFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.data = {};
    }
  }
});
export const {
  settingsRequest,
  settingsSuccess,
  settingsFailure
} = settingsSlice.actions;
export default settingsSlice.reducer;